module.exports = __webpack_public_path__ + "static/logo-b97569d8d1295605ea95ac0251c67878.png";